import axios, { AxiosRequestConfig, AxiosResponse } from 'axios';
import { normalizeApiError } from './apiError';
import { deduplicateGetRequests } from './deduplicateGetRequests';

export const apiClient = axios.create({ baseURL: process.env.REACT_APP_API_URL, withCredentials: true });
export const anonymousClient = axios.create({ baseURL: process.env.REACT_APP_API_URL, withCredentials: false });

for (const client of [apiClient, anonymousClient]) {
    deduplicateGetRequests(client);
    client.interceptors.response.use(response => response, error => Promise.reject(normalizeApiError(error)));
}

export const responseBody = <T,>(response: AxiosResponse<T>): T => response.data;

export const requests = {
    get: <T = any>(url: string) => apiClient.get<T>(url).then(responseBody),
    getConfig: <T = any>(url: string, config: AxiosRequestConfig) => apiClient.get<T>(url, config).then(responseBody),
    post: <T = any>(url: string, body: unknown, config: AxiosRequestConfig = {}) => apiClient.post<T>(url, body, config).then(responseBody),
    put: <T = any>(url: string, body: unknown) => apiClient.put<T>(url, body).then(responseBody),
    delete: <T = any>(url: string) => apiClient.delete<T>(url).then(responseBody)
};
